import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import Button from 'components/Button';
import Pill, { TeamPill, UserPill } from 'components/Pill';
import InlineList from 'components/InlineList';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import Text from 'components/Text';
function AudienceIncludingUsersField(_ref) {
  var onAddTeams = _ref.onAddTeams,
    onRemoveTeam = _ref.onRemoveTeam,
    onAddUsers = _ref.onAddUsers,
    onRemoveUser = _ref.onRemoveUser,
    onSetEveryone = _ref.onSetEveryone,
    teams = _ref.teams,
    users = _ref.users,
    horizontal = _ref.horizontal,
    label = _ref.label,
    description = _ref.description,
    isLockedToTeam = _ref.isLockedToTeam;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var teamsButtonLabel = teams.length === 0 ? t('actions_select_teams') : t('actions_edit_teams');
  var usersButtonLabel = users.length === 0 ? t('actions_select_users') : t('actions_edit_users');
  var teamsButtonIcon = teams.length === 0 ? 'plus' : 'edit';
  var usersButtonIcon = users.length === 0 ? 'plus' : 'edit';
  return /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: label || t('property_audience'),
    horizontal: horizontal
  }, teams.length === 0 && users.length === 0 ? /*#__PURE__*/React.createElement(Pill, {
    as: "p"
  }, t('state_everyone')) : /*#__PURE__*/React.createElement(React.Fragment, null, description && /*#__PURE__*/React.createElement(Flag, {
    token: /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      name: "info",
      dimmed: true
    }),
    spacing: "xs",
    my: "xs"
  }, /*#__PURE__*/React.createElement(Text, null, description)), /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs"
  }, [].concat(_toConsumableArray(teams.map(function (team) {
    var id = team.id,
      name = team.name;
    return /*#__PURE__*/React.createElement(TeamPill, {
      key: id,
      team: team,
      onDelete: function onDelete() {
        return onRemoveTeam(id);
      },
      deleteLabel: t('actions_remove_team', {
        name: name
      })
    });
  })), _toConsumableArray(users.map(function (user) {
    var id = user.id,
      name = user.name;
    return /*#__PURE__*/React.createElement(UserPill, {
      key: id,
      user: user,
      onDelete: function onDelete() {
        return onRemoveUser(id);
      },
      deleteLabel: t('actions_remove_user', {
        name: name
      })
    });
  }))))), /*#__PURE__*/React.createElement(Box, {
    mt: "xs"
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs",
    top: "xs"
  }, !isLockedToTeam && /*#__PURE__*/React.createElement(Button, {
    icon: teamsButtonIcon,
    onClick: onAddTeams,
    size: "medium"
  }, teamsButtonLabel), /*#__PURE__*/React.createElement(Button, {
    icon: usersButtonIcon,
    onClick: onAddUsers,
    size: "medium"
  }, usersButtonLabel), (teams.length !== 0 || users.length !== 0) && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    onClick: onSetEveryone
  }, t('actions_set_audience_to_everyone')))));
}
export default AudienceIncludingUsersField;